import type { CssGeneratorContext } from '../css-generator.model';

/** AccordionSection — only layout helpers; header/content styling comes from the Optimus accordion theme. */
export const styles = ({ dt }: CssGeneratorContext) => `
.accordion-sections-grid {
  display: grid;
  gap: ${dt('accordionSection.sectionGap')} !important;
}

app-accordion-section .accordion-section-content {
  gap: ${dt('accordionSection.contentGap')} !important;
}
`;
